module.exports = __webpack_public_path__ + "assets/normal/images/fog.534311d0.png";